import api from "./main";

/**
 * 遊戲列表
 * @param {String} data.clientId
 * @param {String} data.clientKey
 * @param {String} data.lang // 多語系: zh,en,th,pt 非必填預設為en
 * @returns
 */
export const gameList = (data) => {
  return api({
    url: '/agent/v2/player/gameList',
    method: 'post',
    data
  })
}

/**
 * 遊戲列表
 * @param {String} data.clientId
 * @param {String} data.clientKey
 * @param {String} data.agentName
 * @param {String} data.userName
 * @param {String} data.lang // 多語系: zh,en,th,pt 非必填預設為en
 * @returns
 */
export const login = (data) => {
  return api({
    url: '/api/v1/operator/get_member_token',
    method: 'post',
    data
  })
}

/**
 * 取得遊戲連結
 * @param {String} data.gameCode
 * @param {String} data.lang // 多語系: zh,en,th,pt 非必填預設為en
 * @returns
 */
export const entryGame = (data) => {
  return api({
    url: '/agent/v2/player/entryGame',
    method: 'post',
    data
  })
}
